"use strict";

(function (global) {

  /**
  * Навешивает меню на кнопку "Выполнить" для заданий.
  * @since 5.2.0.1500
  * @function Core.toolBars.job.initPerformButton
  */
  global.initPerformButton = function () {
    var button = $('div[name=JobDoIt]');
    var spanText = $('span:first', button);
    spanText.after('<svg class="svg-component toolbar-item__arrow"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#downMenu"></use></svg>');
    button.removeAttr('onclick');

    var menu_items = [];
    var choices = fillJobChoiceText();
    for (var i = 0; i < choices.length; ++i) {
      menu_items.push({
        text: choices[i].DisplayName,
        onClick: (function (performResult) { // замыкание для корректной передачи choices[i], т.к. переменная i меняется в цикле
          return function () {
            global.performResult(performResult);
          }
        })(choices[i])
      });
    }
    var additionalSettings = selectToolbarBtnOnShowContextMenu(button);
    var menu = new ContextMenu(menu_items, {
      shiftX: 0,
      shiftY: 38,
      width: "auto",
      cssClass: "performs-context-menu",
      onShow: function () {
        if (button.hasClass('disabled')) {
          ContextMenu.hide();
          return false;
        }
        additionalSettings.onShow();
      },
      onHide: function () {
        additionalSettings.onHide();
      }
    });
    button.contextMenu(menu);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  // Проверяет наличие параметров ТМ.
  function ExecuteBeforeQueryParamsEvent(performResultCode) {
    var jActiveText;
    if (WA.isMobile()) {
      jActiveText = $('.textarea');
    } else {
      jActiveText = $('.Job_Edit_Text_Area_Control').filter('textarea');
    }
    var activeText = jActiveText.val();

    return WA.SRV.call('/Job.asmx/ExecuteBeforeQueryParamsEvent', {
      JobID: WA.CR.ID,
      PerformResultName: performResultCode,
      ActiveText: (activeText) ? activeText : ""
    }).done(function (r) {
      jActiveText.val(r.newActiveText);
    });
  }

  //Выполнение задания с результатами выполнения и запрашиваемыми параметрами.
  function JobWFSetResult(el) {
    UnbindBeforeUnload();
    $("#__RESULT_VAR").val(el.id);
    // Вызвать событие "До запроса параметров", если по ТМ и означено.
    WebAccess.Job.fireAll("ParamAsking", function () { DoAction('__POSTBACK_ACTION=AcceptWfVar', true) });
  }

  //Выполнение задания с результатами выполнения без запрашиваемых параметров.
  function JobWFParams(el) {
    UnbindBeforeUnload();
    $("#__RESULT_VAR").val(el.id);

    WebAccess.Job.fireAll("ParamAsking", function () {
      if (GetParamInURL("op") != "") {
        DoAction('__POSTBACK_ACTION=ShowParams', true, RemoveParamInURL($('form:first').attr('action'), 'op'));
      } else {
        DoAction('__POSTBACK_ACTION=ShowParams', true);
      }
    });
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  /**
   * Действие на кнопку "Выполнить" для заданий.
   * @since 5.2.0.1500
   * @function Core.toolBars.job.perform
   */
  global.perform = function (event) {
    if (!CheckIsWf()) {
      // Задание не по ТМ.
      ConfirmDialogNew(L("CONFIRM_JOB_PERFORM"), function () {
        UnbindBeforeUnload();
        DoAction('__POSTBACK_ACTION=ApproveWf', true);
      });
    } else {
      if (ResultNotEmpty()) {
        // Есть результаты выполнения.
        DoItAdditionalAction(event);
      } else {
        ConfirmDialogNew(L("CONFIRM_JOB_PERFORM"), function () {
          // Нет результатов выполнения.
          ExecuteBeforeQueryParamsEvent('').done(function (r) {
            if (r.hasAskableParams) {
              // Есть запрашиваемые параметры.
              JobWFParamsEmptyResult();
            } else {
              // Нет запрашиваемых параметров.
              JobWFSetEmptyResult();
            }
          });
        });
      }
    }
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  //Выполнение задания без результатов выполнения, но с запрашиваемыми параметрами.
  function JobWFParamsEmptyResult() {
    UnbindBeforeUnload();
    WebAccess.Job.fireAll("ParamAsking", function () {
      if (GetParamInURL("op") != "") {
        DoAction('__POSTBACK_ACTION=ShowParams', true, RemoveParamInURL($('form:first').attr('action'), 'op'));
      } else {
        DoAction('__POSTBACK_ACTION=ShowParams', true);
      }
    });
  }

  //Выполнение задания без результатов выполнения и без запрашиваемыми параметрами.
  function JobWFSetEmptyResult() {
    UnbindBeforeUnload();
    // Вызвать событие "До запроса параметров", если по ТМ и означено.
    WebAccess.Job.fireAll("ParamAsking", function () { DoAction('__POSTBACK_ACTION=AcceptWfEmpty', true); });
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Кнопка "Выполнить с результатом выполнения" для заданий.
   * @since 5.2.0.1500
   * @function Core.toolBars.job.performResult
   */
  global.performResult = function (performResult) {
    ConfirmDialogNew(L("CONFIRM_JOB_PERFORM_RESULT", performResult.DisplayName), function () {
      ExecuteBeforeQueryParamsEvent(performResult.Name).done(function (r) {
        if (r.hasAskableParams) {
          JobWFParams({ id: performResult.Index });
        } else {
          JobWFSetResult({ id: performResult.Index });
        }
      });
    });
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Кнопка "Выполнить с результатом выполнения" для заданий.
   * @since 5.2.0.1500
   * @function Core.toolBars.job.performResultInMobile
   */
  global.performResultInMobile = function (resultEl) {
    global.performResult({
      Name: $(resultEl).text(),
      Index: resultEl.id
    });
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  // Отображение вариантов выполнения.
  function DoItAdditionalAction() {
    var isMobile = $('html').hasClass('mobile');
    if (isMobile) {
      var m = $("table.AddActions");
      m.find('td').empty().html(fillJobChoiceText());
      m.show();
    } else {
      // Тут нет, т.к. в основной версии кнопка переопределяется и при нажатии выводится контекстное меню.
    }
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


})(window.Core.toolBars.job);